import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {environment} from '../environments/environment';


const routes: Routes = [
  { path: '', redirectTo: environment.homePage, pathMatch: "full" },
   {
     path: 'main',
     loadChildren: './main/main.module#MainModule'
   },
   {
    path: 'demo',
    loadChildren: './demo/demo.module#DemoModule'
  },
  {
    path: 'pfev',
    loadChildren: () => import('@fs/pfev/theproject').then(m => m.PfevTheprojectModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'enabled'  })],
  exports: [RouterModule]
})

export class AppRoutingModule {
 }
